import * as React from 'react';

import { ControlButton } from '../../ControlButton';
import { SaveSearch } from '../../Icons';

import * as styles from './styles.css';

interface ISaveSearchButtonProps {
  onClick(): void;
}

export function SaveSearchButton({ onClick }: ISaveSearchButtonProps) {
  return (
    <ControlButton title="Сохранить поиск" className={styles['navigation-btn']} onClick={onClick}>
      <SaveSearch />
    </ControlButton>
  );
}
